module.exports = "<div class=\"middle-box text-center animated fadeInDown\">\r\n    <h1>404</h1>\r\n    <h3 class=\"font-bold\">Página no encontrada</h3>\r\n    <div class=\"error-desc\">\r\n        Lo sentimos, pero la página que esta buscando no a sido encontrada. Verifique la URL si exite algún error.\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/errores/404.template.html
// module id = ../../../../../src/app/components/common/errores/404.template.html
// module chunks = 0